import React, { Component } from 'react';

import SchedulePage from '../components/SchedulePage';

export default class Schedule extends Component {
  render() {
    return <SchedulePage />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/schedule.jsx